import React, { PropsWithChildren } from 'react';
import { Hyperlink } from '../../atoms/Hyperlink';
import { ISonURL } from '../../../types/IUrl';
import { Strong } from '../../atoms/Strong/Strong';

type CurrentUserInformationProps = PropsWithChildren<{
  profileLink: ISonURL;
  withComma?: boolean;
}>;

export default function CurrentUserInformation({
  children,
  profileLink,
  withComma = true,
}: CurrentUserInformationProps) {
  return (
    <div className="current-user-information">
      <p className="current-user-information__info-text">
        <Hyperlink to={profileLink.url} className="current-user-information__info-text--link">
          <Strong>{profileLink.name}</Strong>
        </Hyperlink>
        {withComma ? <span>, </span> : <span> </span>}
        {children}
      </p>
    </div>
  );
}
